// src/components/Header.js
import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FaWhatsapp, FaInstagram, FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/pc/logo.png"
import "../layouts/Header.css";


const sections = [
  { id: "section1", label: "SOMOS" },
  { id: "section2", label: "SERVICIOS" },
  { id: "section4", label: "ALIADOS" },
  { id: "section5", label: "CONOCENOS" },
];

const Header = ({
  screenRef1,
  screenRef2,
  screenRef4,
  screenRef5,
}) => {
  const refs = {
    section1: screenRef1,
    section2: screenRef2,
    section4: screenRef4,
    section5: screenRef5,
  };
  const [active, setActive] = useState("section1");
  const [menuOpen, setMenuOpen] = useState(false);

  // Detectar sección activa al hacer scroll
  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY + 60; // 70 px para compensar header
      let current = "section1";
      sections.forEach(({ id }) => {
        const top = refs[id].current.offsetTop;
        if (scrollY >= top) current = id;
      });
      setActive(current);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [refs]);

  return (
    <header className="main-header">
      <div className="header-content">
        <img src={logo} alt="Logo" className="logo" />

        {/* Desktop */}
        <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>
          <ul className="nav-list">
            {sections.map(({ id, label }) => (
              <li key={id} className={active === id ? "active" : ""}>
                <Link
                  to={id}
                  spy
                  smooth
                  offset={-60}
                  duration={500}
                  onClick={() => {
                    setMenuOpen(false);
                    setActive(id);
                  }}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <ul className="social-list">
            {/*       <li>
            <a
              href="https://wa.me/5493512081470"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
          </li> */}
          <li>
            <a
              href="https://www.instagram.com/enjoyproduccionintegral/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </li>
        </ul>
        {/* Mobile Hamburger */}
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
};

export default Header;
